import * as React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';

import Row from 'components/Row';
import Box from 'components/Box';
import Text from 'components/Text';

import BoxBody from 'components/BoxBody';
import Link from 'components/Link';
import Icon from 'components/Icon';

import MediaObject from 'components/MediaObject';
import EventTracking from 'lib/EventTracking';
import './styles/NavigationListGroupItemDeprecated.scss';

export default class NavigationManageCoaching extends React.Component {
  componentDidMount() {
    EventTracking.trackKey('coaching.manage.nav_list.view');
  }
  render() {
    return (
      <Row size="small">
        <Box size="xsmall">
          <BoxBody size="xxsmall">
            <Link
              block
              color="pitch"
              className="ClassNavigationManageCoaching"
              to={CoachingConstants.COACHING_AVAILABILITY_ROUTE}
              eventKey="coaching.manage.nav_list.click">
              <MediaObject gutter="xsmall">
                <Icon name="calendar" size="large"></Icon>
                <Text align="left" lineHeight="medium" size="xsmall" weight="semibold">
                  {CoachingConstants.MANAGE_COACH_AVAILABILITY}
                </Text>
              </MediaObject>
            </Link>
          </BoxBody>
        </Box>
      </Row>
    );
  }
}
